import get from 'lodash/get';
import error from 'aurora-utils/error';
import * as types from './constants';

const initialState = {
  loading: false,
  error,
  status: null,
  isModalOpen: false,
  paymentResponse: null,
  adPayResponse: null,
  makePaymentError: null,
  fees: null,
};

export default function paymentReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.WALLET_TOP_UP:
      return {
        ...state,
        loading: true,
        status: 'progress',
        query: get(action.payload, 'query'),
      };
    case types.WALLET_TOP_UP_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentResponse: get(action.payload, 'payment'),
        error,
      };
    case types.WALLET_TOP_UP_ERROR:
      return {
        ...state,
        loading: false,
        status: 'failed',
        error: get(action.payload, 'error'),
      };
    case types.ADMIN_PAYMENT:
      return {
        ...state,
        loading: true,
        status: 'progress',
        query: get(action.payload, 'query'),
      };
    case types.ADMIN_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentResponse: get(action.payload, 'payment'),
        error,
      };
    case types.ADMIN_PAYMENT_ERROR:
      return {
        ...state,
        loading: false,
        status: 'failed',
        error: get(action.payload, 'error'),
      };
    case types.CONFIRM_PAYMENT:
      return {
        ...state,
        status: 'progress',
        isModalOpen: true,
        adPayResponse: get(action.payload, 'adPayResponse'),
        makePaymentError: null,
        query: get(action.payload, 'query'),
      };
    case types.CONFIRM_PAYMENT_SUCCESS:
      return {
        ...state,
        status: 'success',
        isModalOpen: true,
        paymentResponse: get(action.payload, 'payment'),
        error,
      };
    case types.CONFIRM_PAYMENT_ERROR:
      return {
        ...state,
        status: 'failed',
        isModalOpen: true,
        error: get(action.payload, 'error'),
      };
    case types.ADPAY_FAILED:
      return {
        ...state,
        status: 'failed',
        isModalOpen: true,
      };
    case types.TOGGLE_MODAL:
      return {
        ...state,
        isModalOpen: !state.isModalOpen,
        status: null,
      };
    case types.FETCH_FEES:
      return {
        ...state,
        loading: true,
        error: null,
        makePaymentError: null,
        query: get(action.payload, 'query'),
      };
    case types.FETCH_FEES_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentResponse: get(action.payload, 'payment'),
        error: null,
        makePaymentError: null,
      };
    case types.FETCH_FEES_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    case types.MAKE_PAYMENT:
      return {
        ...state,
        loading: true,
        makePaymentError: null,
        query: get(action.payload, 'query'),
      };
    case types.MAKE_PAYMENT_SUCCESS:
      return initialState;
    case types.MAKE_PAYMENT_ERROR:
      return {
        ...state,
        loading: false,
        makePaymentError: get(action.payload, 'error'),
      };
    case types.CONFIRM_PAYMENT_SERVICE:
      return {
        ...state,
        loading: true,
        query: get(action.payload, 'query'),
      };
    case types.CONFIRM_PAYMENT_SERVICE_SUCCESS:
    case types.RESET_PAYMENT_REDUCER:
      return initialState;
    case types.CONFIRM_PAYMENT_SERVICE_ERROR:
      return {
        ...state,
        loading: false,
        makePaymentError: get(action.payload, 'error'),
      };
    case types.CERTIFICATE_CLEAR_DATA:
      return initialState;
    case types.FETCH_PAYMENT_BREAKDOWN:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentResponse: get(action.payload, 'paymentResponse'),
      };
    case types.FETCH_PAYMENT_BREAKDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    case types.ADMIN_FETCH_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentResponse: get(action.payload, 'payment'),
      };
    case types.RESET_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        paymentResponse: null,
      };
    case types.RESET_MAKE_PAYMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        makePaymentError: null,
      };
    default:
      return state;
  }
}
